<ngx-charts-chart [view]="[width, height]" [showLegend]="legend" [legendOptions]="legendOptions" [activeEntries]="activeEntries"
  (legendLabelClick)="onClick($event)">
  <svg:g [attr.transform]="transform" class="area-chart chart">
    <svg:g np-ngx-charts-x-axis *ngIf="xAxis" [xScale]="xScale" [dims]="dims" [showGridLines]="showGridLines" [showLabel]="showXAxisLabel"
      [labelText]="xAxisLabel" [tickFormatting]="xAxisTickFormatting" [ticks]="xAxisTicks" (dimensionsChanged)="updateXAxisHeight($event)">
    </svg:g>
    <svg:g np-ngx-charts-y-axis *ngIf="yAxis" [yScale]="yScale" [dims]="dims" [showGridLines]="showGridLines" [showLabel]="showYAxisLabel"
      [labelText]="yAxisLabel" [tickFormatting]="yAxisTickFormatting" [ticks]="yAxisTicks" (dimensionsChanged)="updateYAxisWidth($event)">
    </svg:g>
    <svg:g [attr.clip-path]="clipPath">
      <svg:g *ngFor="let series of results">

        <svg:g np-ngx-charts-line-series [xScale]="xScale" [yScale]="yScale" [colors]="colorLines" [data]="series" [activeEntries]="activeEntries"
          [scaleType]="scaleType" [curve]="curve" [rangeFillOpacity]="rangeFillOpacity" [hasRange]="true"></svg:g>
        <svg:g ngx-charts-area-series [xScale]="xScale" [yScale]="yScale" [baseValue]="baseValue" [colors]="colors" [data]="series"
          [activeEntries]="activeEntries" [scaleType]="scaleType" [gradient]="gradient" [curve]="curve">
        </svg:g>


        <svg:g np-ngx-charts-circle-series-white [xScale]="xScale" [yScale]="yScale" [colors]="colors" [activeEntries]="activeEntries"
          [data]="series" [scaleType]="scaleType" [visibleValue]="hoveredVertical" [tooltipDisabled]="tooltipDisabled" [tooltipTemplate]="tooltipTemplate"
          (select)="onClick($event, series)">
        </svg:g>
        <svg:g np-ngx-charts-circle-series [xScale]="xScale" [yScale]="yScale" [colors]="colors" [activeEntries]="activeEntries"
          [data]="series" [scaleType]="scaleType" [visibleValue]="hoveredVertical" [tooltipDisabled]="tooltipDisabled" [tooltipTemplate]="tooltipTemplate"
          (select)="onClick($event, series)">
        </svg:g>

      </svg:g>

    </svg:g>
  </svg:g>
</ngx-charts-chart>